// const Reviews = () =>
//     import("@/components/dashboard/doctor/Reviews.vue");
const SearchPatientN = () =>
  import("@/components/dashboard/doctor/searchPatient/searchPatientN");
const OpinionPoll = () => import("@/components/dashboard/doctor/ComingSoon");
const Appointments = () =>
  import("@/components/dashboard/doctor/AppointmentsMain");
// import OnlineConsultation from "@/components/dashboard/doctor/OnlineConsultation";
const Grievances = () => import("@/components/dashboard/doctor/ComingSoon");
const SetAlerts = () => import("@/components/dashboard/doctor/SetAlerts");
const Accounts = () => import("@/components/dashboard/doctor/Accounts");
const Prescriptions = () =>
  import("@/components/dashboard/doctor/Prescriptions");
const DoctorHomeVisit = () =>
  import("./../../components/dashboard/doctor/HomeVisit/DoctorHomeVisit");
const ComingSoon = () => import("@/components/dashboard/doctor/ComingSoon");
const MyWallet = () => import("@/components/dashboard/doctor/MyWallet");
const Gallery = () => import("@/components/dashboard/doctor/DoctorGallery");
import GalleryRoutes from "@/routes/dashboard/AlliedGallery";
const Documents = () =>
  import("@/components/dashboard/doctor/myDocuments/myDocuments");
const Orders = () => import("@/components/dashboard/doctor/ComingSoon");
const MedicalCalculators = () =>
  import("@/components/dashboard/doctor/ComingSoon");
const Favourites = () =>
  import("@/components/dashboard/doctor/favourites/Favourites");
const Reports = () => import("@/components/dashboard/doctor/Reports");
const PatientGallery = () =>
  import("@/components/dashboard/doctor/DoctorPatientGallery");
const PatientGalleryDetail = () =>
  import("@/components/dashboard/doctor/PatientGalleryDetail");
const RedFlag = () => import("@/components/dashboard/doctor/Flag/RedFlag");
const certificateDetailList = () =>
  import("@/components/dashboard/doctor/myDocuments/certificateDetailList");
const consentFormDetailList = () =>
  import("@/components/dashboard/doctor/myDocuments/consentFormDetailList");
const FavouritesDoctor = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesDoctor");
const FavouritesAmbulance = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesAmbulance");
const FavouritesDiagnostics = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesDiagnostics");
const FavouritesPharmacy = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesPharmacy");
const FavouritesBloodbank = () =>
  import("@/components/dashboard/doctor/favourites/FavouritesBloodbank");
const DashboardRating = () =>
  import("@/components/dashboard/doctor/DashboardRating");
// const onlineConsultationMain = () =>
//   import(
//     "@/components/dashboard/doctor/onlineConsultation/onlineConsultationMain"
//   );
const onlineConsultationMain = () =>
  import(
    "@/components/newOC/doctorOC/doctorOC"
  );
const templateListing = () =>
  import("@/components/dashboard/doctor/templates/templateListing");
const Dashboard = () => import("@/components/dashboardNew/doctorDashboard.vue");

export default [
  {
    path: "",
    name: "dashboard.allied.root",
    redirect: {
      name: "alliedDashboard"
    }
  },
  {
    path: "dashboard",
    name: "alliedDashboard",
    component: Dashboard
  },
  {
    path: "appointments",
    name: "dashboard.allied.appointments",
    component: Appointments
    // children: appointmentRoutes
  },
  {
    path: "allied-assist",
    name: "dashboard.allied.allied-assist",
    component: Appointments
    // children: assistAppointmentRoutes
  },
  {
    path: "search-patient",
    name: "dashboard.allied.search-patient",
    component: SearchPatientN
  },

  {
    path: "template",
    name: "dashboard.allied.template",
    component: templateListing
  },
  {
    path: "reports",
    name: "dashboard.allied.reports",
    component: Reports
  },
  {
    path: "prescriptions",
    name: "dashboard.allied.prescriptions",
    component: Prescriptions
  },
  {
    path: "home-visit",
    name: "dashboard.allied.HomeVisit.DoctorHomeVisit",
    component: DoctorHomeVisit
  },
  {
    path: "reviews",
    name: "dashboard.allied.reviews",
    component: DashboardRating
  },
  {
    path: "opinion-poll",
    name: "dashboard.allied.opinion-poll",
    component: OpinionPoll
  },
  {
    path: "online-consultation",
    name: "dashboard.allied.online-consultation",

    component: onlineConsultationMain
  },
  {
    path: "grievances",
    name: "dashboard.allied.grievances",
    component: Grievances
  },
  {
    path: "set-alerts",
    name: "dashboard.allied.set-alerts",
    component: SetAlerts
  },
  {
    path: "accounts",
    name: "dashboard.allied.accounts",
    component: Accounts
  },
  {
    path: "my-wallet",
    name: "dashboard.allied.myWallet",
    component: MyWallet
  },
  {
    path: "ipd",
    name: "dashboard.allied.ipd",
    component: ComingSoon
  },
  {
    path: "my-events",
    name: "dashboard.allied.my-events",
    component: ComingSoon
  },
  {
    path: "gallery",
    name: "dashboard.allied.gallery",
    component: Gallery,
    children: GalleryRoutes,
    redirect: {
      name: "dashboard.allied.gallery.images"
    }
    // children: [{
    //     path: "DoctorMyGallery",
    //     name: "dashboard.allied.DoctorMyGallery",
    //     component: DoctorMyGallery
    // }]
  },
  {
    path: "patient-gallery",
    name: "dashboard.allied.patient-gallery",
    component: PatientGallery
  },
  {
    path: "patientGalleryDetail",
    name: "dashboard.allied.patientGalleryDetail",
    component: PatientGalleryDetail,
    params: true
  },

  {
    path: "myDocuments",
    name: "dashboard.allied.myDocuments",
    component: Documents
  },
  {
    path: "myOrders",
    name: "dashboard.allied.myOrders",
    component: Orders
  },

  {
    path: "RedFlag",
    name: "dashboard.allied.RedFlag",
    component: RedFlag
  },
  {
    path: "medicalCalculators",
    name: "dashboard.allied.medicalCalculators",
    component: MedicalCalculators
  },

  {
    path: "certificateDetailList",
    name: "dashboard.allied.certificateDetailList",
    component: certificateDetailList
  },
  {
    path: "consentFormDetailList",
    name: "dashboard.allied.consentFormDetailList",
    component: consentFormDetailList
  },

  {
    path: "favourites",
    name: "dashboard.allied.favourites",
    component: Favourites,
    redirect: {
      name: "dashboard.allied.favourites.doctor"
    },
    children: [
      {
        path: "allied",
        name: "dashboard.allied.favourites.doctor",
        component: FavouritesDoctor
      },
      {
        path: "ambulance",
        name: "dashboard.allied.favourites.ambulance",
        component: FavouritesAmbulance
      },
      {
        path: "diagnostics-lab",
        name: "dashboard.allied.favourites.diagnostics-lab",
        component: FavouritesDiagnostics
      },
      {
        path: "pharmacy",
        name: "dashboard.allied.favourites.pharmacy",
        component: FavouritesPharmacy
      },
      {
        path: "bloodbank",
        name: "dashboard.allied.favourites.bloodbank",
        component: FavouritesBloodbank
      }
    ]
  }
];
